import React from 'react';

export default class Page9 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToBeAnEffectiveRoleModel');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToIdentifyYourPersonalMeaning')}>How
                                                        to identify your personal meaning</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToIdentifyPersonalLearningStyles')}>How
                                                        to identify personal learning styles</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}>How
                                                        to get the most out of yourself</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMakeEthicalDecisions')}>How
                                                        to make ethical decisions.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> Walters R. &amp; Doan,
                                                    H. (1962). Reported by Lamont, N. (1962).<span
                                                        className="subtiltereg"> Report on the O.P.A. 1962 Annual Meeting.
                                The Canadian Psychologist.</span> Apr 3a(2) 67-70.</p></li>
                                                <li><p className="further_info_content">Mann, R. (1959). A
                                                    review of the relationship between personality and
                                                    performance in small groups.<span className="subtiltereg"> Journal
                                of Personality and Social Psychology,</span> 42, 260-272.</p></li>
                                                <li><p className="further_info_content">Mullen, B., Salas,
                                                    E. &amp; Driskell, J. (1989). Salience, motivation, and
                                                    artefact as contributions to the relation
                                                    between participation rate and leadership.<span
                                                        className="subtiltereg"> Journal of Experimental Social Psychology,</span> 25,
                                                    545-559.
                                                </p></li>
                                                <li><p className="further_info_content">Stodgill, R.
                                                    (1974).<span
                                                        className="subtiltereg"> Handbook of Leadership.</span> New
                                                    York: Free Press.</p></li>

                                                <li><p className="further_info_content">Bandura, A. (1977).<span
                                                    className="subtiltereg"> Social Learning Theory.</span> Englewood
                                                    Cliffs, NJ: Prentice Hall.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}